"use client";

import { usePathname } from "next/navigation";
import ContactInfo, { type ContactInfoProps } from "./contact-info";

type FooterContactInfoProps = ContactInfoProps & {
  residencePhone?: string;
};

export default function FooterContactInfo({
  residencePhone,
  ...props
}: FooterContactInfoProps) {
  const pathname = usePathname();
  const isResidencePage = pathname.endsWith("/residence");

  return (
    <ContactInfo
      {...props}
      phoneNumber={isResidencePage ? residencePhone : undefined}
    />
  );
}
